import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { RouteSeo } from './components/RouteSeo';
import { Home } from './pages/Home';
import { Adventure } from './pages/Adventure';
import { Worlds } from './pages/Worlds';
import { Parents } from './pages/Parents';
import { Pricing } from './pages/Pricing';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Support } from './pages/Support';
import { NotFound } from './pages/NotFound';
import { AnalyticsGate } from './components/consent/AnalyticsGate';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31c1i2bzpdug9">
      <RouteSeo data-id="element-1" data-mp="31cjo20c63n1d" />
      <SiteLayout data-id="element-2" data-mp="2wka20ve6b74d">
        <Routes data-id="element-3" data-mp="2wjqgz5t882m4">
          <Route path="/" element={<Home data-id="element-5" data-mp="2wip6p3k1bk5g" />} data-id="element-4" data-mp="2wj8dpp85co4p" />
          <Route path="/adventure" element={<Adventure data-id="element-7" data-mp="28tmdcyg1g2v4" />} data-id="element-6" data-mp="28ufpkexrnkkn" />
          <Route path="/worlds" element={<Worlds data-id="element-9" data-mp="28s2xh8yanttv" />} data-id="element-8" data-mp="28sutulzptvl7" />
          <Route path="/parents" element={<Parents data-id="element-11" data-mp="23ujksdh8vp41" />} data-id="element-10" data-mp="23vkzqt1dsvr1" />
          <Route path="/pricing" element={<Pricing data-id="element-13" data-mp="3ijxsgzk2wgo4" />} data-id="element-12" data-mp="23v2tr4ox335x" />
          <Route path="/privacy" element={<Privacy data-id="element-15" data-mp="3ijfu9xduvsdk" />} data-id="element-14" data-mp="3ikqyfyb7r257" />
          <Route path="/terms" element={<Terms data-id="element-17" data-mp="3ml1419v3fqjj" />} data-id="element-16" data-mp="3ii4sg33z0up3" />
          <Route path="/support" element={<Support data-id="element-19" data-mp="3mjpyb4i388ps" />} data-id="element-18" data-mp="3mkho1yp07c85" />
          <Route path="*" element={<NotFound data-id="element-21" data-mp="3rbrcwx2qabiz" />} data-id="element-20" data-mp="3rc9d24sih9w6" />
        </Routes>
      </SiteLayout>
      <AnalyticsGate data-id="element-22" data-mp="3reltuemj9e7n" />
    </BrowserRouter>;
}